import $ from 'jquery';
import { toggleContentLoader } from '../utils/content-loader';
import SetDropdownValue from './set-dropdown-value';
import { CheckboxTreeSync } from './checkbox-tree-sync';
const ELEMENT_SELECTOR = '.js__ajax-content-container';
export default class AjaxContent {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        $element.each((index, element) => {
            const $element = $(element);
            $.ajax({
                method: 'get',
                url: $element.data('url'),
                beforeSend() {
                    toggleContentLoader($element, true);
                },
            })
                .done(data => {
                $element.html(data);
                $element.find('.ui.dropdown, select').dropdown();
                SetDropdownValue.init();
                // @ts-ignore
                $element.find('.ui.checkbox').checkbox();
                CheckboxTreeSync.init($element);
            })
                .fail(xhr => {
                $element.html('<div class="text-red">Ooops! Something went wrong.</div>');
            })
                .always(() => {
                toggleContentLoader($element, false);
            });
        });
    }
}
